import { BulkReturnActionResultSchema } from "@redotech/redo-return-core-common/return-actions/types";
import * as z from "zod";

export const BulkReturnActionRunStatus = z.enum([
  "running",
  "completed",
  "failed",
  "not_found",
]);
export type BulkReturnActionRunStatus = z.infer<
  typeof BulkReturnActionRunStatus
>;

export const BulkReturnActionRun = z.object({
  status: BulkReturnActionRunStatus,
  /**
   * Every return in the run, in selection order. Live while running, final
   * once completed; absent when the run cannot be read.
   */
  results: z.array(BulkReturnActionResultSchema).optional(),
});
export type BulkReturnActionRun = z.infer<typeof BulkReturnActionRun>;

export const getBulkReturnActionRun = {
  name: "getBulkReturnActionRun" as const,
  input: z.object({ runId: z.string() }),
  output: BulkReturnActionRun,
};
